import React from 'react';

const FEATURES = [
  {
    title: 'Smart Metering',
    desc: 'Accurate, intelligent measurement of electricity consumption.',
    icon: <path d="M3 3v18h18M18.7 8l-5.1 5.2-2.8-2.7L7 14.3" />,
  },
  {
    title: 'Real-Time Energy Insights',
    desc: 'Monitor energy consumption and usage patterns as they happen.',
    icon: <><path d="M3 17l5-5 4 4 8-9" /><path d="M14 7h6v6" /></>,
  },
  {
    title: 'Remote Payments',
    desc: 'Purchase electricity tokens via SMS, web portal, or mobile app.',
    icon: <><rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" /></>,
  },
  {
    title: 'Meter Auto Calibration',
    desc: 'Supports accurate and reliable meter performance.',
    icon: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 3" /></>,
  },
  {
    title: 'High Accuracy',
    desc: 'Precise energy measurements for reliable insights.',
    icon: <path d="M12 2l2.4 7.2H22l-6 4.4 2.4 7.2-6.4-4.6-6.4 4.6 2.4-7.2-6-4.4h7.6z" />,
  },
  {
    title: 'Geyser Control',
    desc: 'Remote, scheduled control of geyser energy consumption.',
    icon: <><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" /></>,
  },
  {
    title: 'Demand Management',
    desc: 'Supports demand-side management and ripple-control functionality.',
    icon: <path d="M13 2 4 14h6l-1 8 9-12h-6l1-8z" />,
  },
  {
    title: 'Connectivity',
    desc: 'Integrated modem and Wi-Fi router supporting 4G, 3G and fibre.',
    icon: <><path d="M5 12.55a11 11 0 0 1 14.08 0" /><path d="M1.42 9a16 16 0 0 1 21.16 0" /><path d="M8.53 16.11a6 6 0 0 1 6.95 0" /><circle cx="12" cy="20" r="1" fill="currentColor" stroke="none" /></>,
  },
  {
    title: 'GRIDx Cloud',
    desc: 'Centralised cloud-based monitoring, control and energy intelligence.',
    icon: <path d="M7 18a4 4 0 0 1-.5-7.97A5.5 5.5 0 0 1 17.3 8.3 4.5 4.5 0 0 1 17 18H7z" />,
  },
];

const CoreFunctionality = () => (
  <section className="gh-section cf">
    <div className="gh-section__inner">
      <span className="eyebrow">Core functionality</span>
      <h2 className="gh-section__title">Everything the meter coordinates.</h2>

      <div className="cf__grid">
        {FEATURES.map((f) => (
          <div key={f.title} className="cf__hex-wrap">
            <div className="cf__hex">
              <div className="cf__hex-inner">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" className="cf__icon">
                  {f.icon}
                </svg>
                <h3 className="cf__title">{f.title}</h3>
                <p className="cf__desc">{f.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CoreFunctionality;
